import $ from "jquery"

export function ColorCodeSelector({style,initial,onSelected}){

    style = $.extend({
        width : '12.5em',
        height : '12.5em',
        backgroundColor : 'white',
        border : 'solid 1px grey',
    },style)

    var cells = [];
    for (var r=0 ; r<8 ; r++ ){
        for (var c = 0 ; c<8 ; c++){
            (function(r,c){
                cells.push(<div
                    style ={{
                        width : '1em',
                        height : '1em',
                        top : ( r*1.5 + 0.5)+"em",
                        left : ( c*1.5 + 0.5)+"em",                    
                        position : 'absolute',
                        backgroundColor : colorCodes[r*8+c]
                    }}
                    onClick={()=>{onSelected(r*8+c)}}
                >
                    <div></div>
                </div>)
            })(r,c)
        }
    }

    return (<div
        style = {style}
    >
        <div style={{
            position:'relative'
        }}>
            {cells}
        </div>
    </div>)

}

export var colorCodes = (()=>{ // 64 colors    
    var cus =['FF','A0','50','00'];
    var rows =[];
    var row=[];
    for (var r=0;r<4;r++){
        for (var g=0;g<4;g++){
            for (var b=0;b<4;b++){
                row.push("#"+cus[r]+cus[g]+cus[b]);
                if (row.length>=8){
                    rows.push(row);
                    row = [];
                }
            }
        }
    }
    var codes= [];
    for (var i = 0 ;i<8;i+=2){
        $.each(rows[i],(c,color)=>{codes.push(color)})
    }
    for (var i = 1 ;i<8;i+=2){
        $.each(rows[i],(c,color)=>{codes.push(color)})
    }
    return codes;
})();

export function PlusMinus ({isOpen,onClick,isVisible}){

    var vertical = !isOpen ?(
        <div 
            style = {{
                position : 'absolute',
                width : '1em',
                height : '1em',
                border : 'solid 1px grey',
                cursor : 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                style={{
                    backgroundColor : 'grey',
                    width :'1px',
                    height : '0.7em',
                    margin : 'auto',
                }}
            ><div></div></div>
            
        </div>
    ):null;

    return ( <div
        id = "margin"
        style={{
            width : '1.2em',
            height : '2em',
            position : 'absolute',
            marginTop : 'auto',
            top: '50%',
            transform: 'translateY(-50%)',
            display : 'flex',
        }}
        onClick = {onClick}
    >
        <div
            style={{
                width : '1.2em',
                height : '100%',
                display : isVisible?'flex':'none',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                style ={{
                    width : '1em',
                    height : '1em',
                    position : 'relative',
                    display : 'inline-block',
                    marginLeft : '0.1em',
                    marginRight : '0.1em',
                }}
            >
                <div 
                    style = {{
                        position : 'absolute',
                        width : '1em',
                        height : '1em',
                        border : 'solid 1px grey',
                        cursor : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <div
                        style={{
                            backgroundColor : 'grey',
                            height :'1px',
                            width : '0.7em',
                            margin : 'auto',
                        }}
                    ><div></div></div>
                </div>
                {vertical}
            </div>
        </div>
    </div>);    

}